import { useState } from 'react';
import { createPortal } from 'react-dom';

export function FullScreenModal({ children, title, isOpen, onClose }) {
  const handleClose = () => {
    onClose(false);
  };

  if (!isOpen) return null;

  return createPortal(
    <div className={`fixed inset-0 z-50 w-full h-full bg-[#043939] flex flex-col p-4 pt-[calc(var(--tg-content-safe-area-inset-top)*1.7+24px)]`}>
      <div className="flex items-center justify-between gap-2 mb-[16.5px]">
        <p className="font-bold text-lg text-white">{title}</p>
        <button onClick={handleClose} className="size-8">
          <img src="/icons/Button-close.svg" alt="close" />
        </button>
      </div>
      <div className="text-white overflow-y-auto">{children}</div>
    </div>,
    document.getElementById('root'),
  );
}
